// 1. 외부 패키지
import { useRecoilValue } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import get_basic_detail_selector, { NoticeModel } from "../../selector/get-basic-detail-selector";
import { getQuery } from "../../shared/function";
import notice_icon from "../../static/img/icons/notice-icon.svg";
import { SERVER_URL } from "../../shared/api-constant";

// 4. 타입


const Notice = () => {

	const data = useRecoilValue(get_basic_detail_selector(getQuery().idx));

	const { notice } = data;

	const onClickFile = (i: NoticeModel) => {
		const path = '/upload' + i.path.split('/upload')[1];

		window.open(`${SERVER_URL}/backend/app/api/download.php?filepath=${path}&filename=${i.original_name}`);
	};

	if ( !notice ) return <></>
	if ( notice.length === 0 ) return <></>

	return (
		<div className='notice-wrapper loaded'>
			<h3>· 고시/공고문</h3>
			<ul>
				{notice.map((i, index) => {
					return (
						<li key={index}>
							<img src={notice_icon} alt='고시 / 공고문 아이콘' />
							<p onClick={() => onClickFile(i)}>
								{i.original_name}
							</p>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default Notice;